import { DS_SHAPE_SPACING, DS_SPACING_UNITS } from '@calm/evexia-design-tokens';
import { Theme } from '@rhg/libs/material';
import {
    INFO_ANIMATION_SIZE_DESKTOP,
    INFO_ANIMATION_SIZE_MOBILE,
} from '../animations/info-animation';
import {
    BOTTOM_ACTION_SECTION_HEIGHT_DESKTOP,
    BOTTOM_ACTION_SECTION_HEIGHT_MOBILE,
} from '../bottom-action';
import {
    BANNER_IMAGE_HEIGHT_MD_PX,
    BANNER_IMAGE_HEIGHT_SM_XS_PX,
} from '../program/banner-image/types';

export const styleBackground = {
    background: (theme: Theme) => theme.palette.gradient.backgroundPrimary,
};

export const styleContainer = {
    position: 'relative',
    // Whole screen height minus the bottom action section height
    height: {
        xs: `calc(100% - ${BOTTOM_ACTION_SECTION_HEIGHT_MOBILE}px)`,
        sm: `calc(100% - ${BOTTOM_ACTION_SECTION_HEIGHT_MOBILE}px)`,
        md: `calc(100% - ${BOTTOM_ACTION_SECTION_HEIGHT_DESKTOP}px)`,
        lg: `calc(100% - ${BOTTOM_ACTION_SECTION_HEIGHT_DESKTOP}px)`,
    },
    overflowY: 'scroll',
};

export const styleCloseButton = {
    position: 'fixed',
    right: {
        lg: DS_SHAPE_SPACING.SIDE_LARGE,
        md: DS_SHAPE_SPACING.SIDE_MEDIUM,
        sm: DS_SHAPE_SPACING.SIDE_SMALL,
        xs: DS_SHAPE_SPACING.SIDE_SMALL,
    },
    top: {
        lg: 22,
        md: 22,
        sm: 40,
        xs: 40,
    },
    backgroundColor: (theme: Theme) =>
        theme.palette.mode === 'light' ? 'mask.white.80p' : 'mask.black.20p',
    zIndex: 1,
};

export const styleInfoIconWrapper = {
    zIndex: 1,
    position: 'absolute',
    width: {
        xs: INFO_ANIMATION_SIZE_MOBILE,
        sm: INFO_ANIMATION_SIZE_MOBILE,
        md: INFO_ANIMATION_SIZE_DESKTOP,
    },
    height: {
        xs: INFO_ANIMATION_SIZE_MOBILE,
        sm: INFO_ANIMATION_SIZE_MOBILE,
        md: INFO_ANIMATION_SIZE_DESKTOP,
    },
    top: {
        md: BANNER_IMAGE_HEIGHT_MD_PX - INFO_ANIMATION_SIZE_DESKTOP / 2,
        sm: BANNER_IMAGE_HEIGHT_SM_XS_PX - INFO_ANIMATION_SIZE_MOBILE / 2,
        xs: BANNER_IMAGE_HEIGHT_SM_XS_PX - INFO_ANIMATION_SIZE_MOBILE / 2,
    },
    left: 0,
    right: 0,
    mx: 'auto',
};

export const styleContent = {
    pt: {
        md: `${36 + INFO_ANIMATION_SIZE_DESKTOP / 2}px`,
        xs: 10,
    },
    pb: {
        md: 47.5,
        xs: 26,
    },
    px: {
        xs: 4,
    },
};

export const styleGraphWrapper = {
    m: DS_SPACING_UNITS.CONTENT,
};
